import { useFormatDateTime, useMessage } from "@hermes/intl";
import {
  DatePicker,
  FilterOutlinedButton,
  FilterSearchButton,
  useScreenDetector,
} from "@hermes/ui";
import { match } from "@hermes/utils";

import type { DoctorsListParams } from "./types";

export const DateFilter = ({
  params,
  onParamsChange,
  variant: variantOverride,
}: {
  params: DoctorsListParams;
  onParamsChange: (params: DoctorsListParams) => void;
  variant?: "filter-search" | "filter-outlined";
}) => {
  const { isMobile } = useScreenDetector();
  const message = useMessage();
  const formatDateTime = useFormatDateTime();

  const variant = variantOverride
    ? variantOverride
    : isMobile
      ? "filter-search"
      : "filter-outlined";

  const ButtonComponent = match(variant, {
    "filter-outlined": () => FilterOutlinedButton,
    "filter-search": () => FilterSearchButton,
  });

  return (
    <DatePicker
      value={params.date}
      onChange={(value) => {
        onParamsChange({ date: value });
      }}
      disabled={{
        before: new Date(),
      }}
    >
      {({ triggerRef, triggerProps }) => (
        <ButtonComponent
          text={
            params.date
              ? formatDateTime(params.date, {
                  day: "numeric",
                  month: "long",
                  year: "numeric",
                })
              : message({
                  id: "common.fields.appointment-date",
                  default: "Дата приема",
                })
          }
          triggerRef={triggerRef}
          triggerProps={triggerProps}
          active={!!params.date}
          clearable
          onClear={() => {
            onParamsChange({ date: undefined });
          }}
        />
      )}
    </DatePicker>
  );
};
